<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-dedication element-without-heading" id="dedication">
<div class="text" id="dedication-text">
<p class="first first-in-chapter first-full-width dedication-content">To sad endings and new beginnings</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width dedication-content">In memory of a dear friend and colleague, Fiona.</p>
<p class="subsq dedication-content">The world lost a little bit of its sparkle when you passed.</p>
<p class="subsq dedication-content">You are missed every day.</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width dedication-content">And to my good friends, Mr &amp; Mrs Smith, AKA The Smervs.</p>
<p class="subsq dedication-content">You are perfect together and I wish you every happiness for the future.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?dbcdbbde